import apiClient from './api';

export interface Manual {
  id: string;
  title: string;
  description: string;
  filename: string;
  icon: string;
}

export const getManualsList = async (userRole?: string): Promise<Manual[]> => {
  const params: any = {};
  if (userRole) {
    params.userRole = userRole;
  }
  
  const response = await apiClient.get('/manuals', { params });
  return response.data;
};

export const getManual = async (type: string, userRole?: string): Promise<string> => {
  const params: any = {};
  if (userRole) {
    params.userRole = userRole;
  }
  
  const response = await apiClient.get(`/manuals/${type}`, {
    responseType: 'text',
    params
  });
  return response.data;
};

export const getManualHtml = async (type: string, userRole?: string): Promise<string> => {
  const params: any = {};
  if (userRole) {
    params.userRole = userRole;
  }
  
  const response = await apiClient.get(`/manuals/${type}/html`, {
    responseType: 'text',
    params
  });
  return response.data;
}; 